import { navigateToSelectedChannelRoute } from 'utils/history';
import { useTourContext, MenuProvider, useSelectedLinkContext, useAdminModeContext } from 'contexts';
import { getBaseClassNameSuffixForStep, TOUR_STEPS } from '../../App/OnBoarding/OnBoardingTour';
import Route from 'routes/Routes';
import type { StateSetter } from 'types';
import MainMenu from './MainMenu';
import AppMenuBackground from './AppMenuBackground';
import AdminNavigationMenu from '@/components/ui/organisms/Admin/AdminNavigationMenu/AdminNavigationMenu';

type AppMenuDrawerProps = {
  mobile?: boolean;
  isOpened?: boolean;
  setIsOpened?: StateSetter<boolean>;
  onMenuItemClick?: Function;
};

const AppMenuDrawer = ({ mobile, isOpened, setIsOpened, onMenuItemClick }: AppMenuDrawerProps): JSX.Element => {
  const { currentStep, isTourOpen } = useTourContext();
  const { selectedLink } = useSelectedLinkContext();
  const { isAdminMode, setIsAdminMode } = useAdminModeContext();

  const getMenuSelectedClassNames = (step?: TOUR_STEPS): string => {
    const baseClassName = getBaseClassNameSuffixForStep(step);

    if (isTourOpen && step === currentStep) {
      return `${baseClassName} selected`;
    }

    return baseClassName;
  };

  const shouldShowMenu = (step?: number): boolean =>
    !isTourOpen || !step || step <= currentStep;

  const goToHomeClick = (): void => {
    if (setIsOpened !== undefined) {
      setIsOpened(false);
    }

    setIsAdminMode(false);

    navigateToSelectedChannelRoute(selectedLink, Route.HOME);
  };

  return (
    <MenuProvider
      getMenuSelectedClassNames={getMenuSelectedClassNames}
      onMenuItemClick={onMenuItemClick}
      shouldShowMenu={shouldShowMenu}
    >
      <AppMenuBackground mobile={mobile} isOpened={isOpened} setIsOpened={setIsOpened} data-testid={isAdminMode ? 'admin-menu' : 'main-menu'}>
        {isAdminMode
        ? <AdminNavigationMenu />
        : <MainMenu
            isTourOpen={isTourOpen}
            goToHomeClick={goToHomeClick}
            setIsOpened={setIsOpened}
          />
        }
      </AppMenuBackground>
    </MenuProvider>
  );
};

export default AppMenuDrawer;
